/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {styled} from "@mui/material/styles";
import {Slider} from "@mui/material";

export const StyledSlider = styled(Slider)(({theme}) => ({
	"& .MuiSlider-thumb ": {
		border: 0,
		backgroundColor: theme.palette.background.default
	},
	"& .MuiSlider-mark": {
		width: 0,
		height: 0,
	},
	"& .MuiSlider-rail": {
		backgroundColor: theme.palette.background.default,
		height: '10px',
		opacity: 1
	},
	"& .MuiSlider-track" : {
		backgroundImage: `linear-gradient(to right, ${theme.palette.primary.light}, ${theme.palette.primary.light})`,
		border: '1px solid transparent',
		borderRadius: theme.shape.borderRadius,
		height: '10px',
	},
	'& .MuiSlider-markLabel': {
		color: theme.palette.textAccent.light
	},
	"*[class*='MuiSlider-markLabel'][data-index='0']": {
		transform: 'none',
	},
	"*[class*='MuiSlider-markLabel'][data-index='1']": {
		transform: 'translateX(-100%)',
	}
}))
